var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u_spin"},[_c('div',{staticClass:"u_spin_i"}),_c('div',{staticClass:"u_spin_i"}),_c('div',{staticClass:"u_spin_i"}),_c('div',{staticClass:"u_spin_i"}),_c('div',{staticClass:"u_spin_i"})])
}]

export { render, staticRenderFns }